export const CAMERA_MESSAGES = {
  FACE_OUTSIDE_AREA:
    'Ensure your face is within the oval frame and click "Take Photo"',
  FACE_INSIDE_AREA: "We can see it now. Take a photo.",
  TAKING_PHOTOS: "Capturing.",
  PHOTOS_TAKEN: "Ensure your face is visible and the photo is not blurry.",
  LOADING_DETECTION: "Initializing face detection...",
  FACE_DETECTION_UNAVAILABLE:
    "Face detection unavailable. You can still take photos manually.",
};

export const FACE_DETECTION_ERRORS = {
  WASM_UNAVAILABLE:
    "Advanced face detection requires WebAssembly support which is unavailable in your browser.",
  MODEL_LOAD_FAILED:
    "Failed to load face detection models. Please try refreshing the page.",
  DETECTION_TIMEOUT: "Face detection took too long to initialize.",
  MEDIAPIPE_INIT_FAILED:
    "Could not initialize face detection. Please check your internet connection.",
};
